export const OBJECT_TYPE = {
  TEXT: 'TextObject',
  IMAGE: 'ImageObject',
  BACKGROUND: 'BackgroundObject',
  CLIP_ART: 'ClipArtObject',
  SHAPE: 'ShapeObject',
  RECT: 'RectObject',
  VIDEO: 'VideoObject',
  PORTRAIT_IMAGE: 'PortraitImage',
  IMAGE_RECTANGLE: 'ImageRectangle',
  IMAGE_CIRCLE: 'ImageCircle',
  MULTI_OBJECT: 'MultiObject'
};

export const FABRIC_OBJECT_TYPE = {
  TEXT: 'textbox'
};

export const SYSTEM_OBJECT_TYPE = {
  TEXT: 'paragraph',
  CLIP_ART: 'clipart',
  IMAGE: 'frame'
};

export const PROTOTYPE_RENDER = {
  RECT: 'Rect',
  ELLIPSE: 'Ellipse',
  IMAGE: 'Image'
};
